/**
 * Normalize license tier from auth user (matches api billing normalization).
 * @param {object|null|undefined} user
 * @returns {string} Uppercase tier code or '' if unknown
 */
export function normalizeUserSubscriptionTier(user) {
  const raw = (user?.licenseAssignment?.tier || user?.subscriptionTier || '')
    .toString()
    .toUpperCase();
  if (raw === 'FREEMIUM') return 'FREE';
  return raw;
}

/** Pro or Enterprise — features like admin analytics & usage */
export function isProOrEnterpriseTier(user) {
  const t = normalizeUserSubscriptionTier(user);
  return t === 'PRO' || t === 'ENTERPRISE';
}
